import React, {ReactNode} from 'react';

import {Menu} from '@reach/menu-button';

import '@reach/menu-button/styles.css';

import {CustomButton, CustomButtonDiv, CustomIcon, CustomMenuButton, Item, List} from './styled';

interface Props {
    children: ReactNode;
    label: string | ReactNode;
    width?: string | number;
    noIcon?: boolean;
}

export class DropdownMenu extends React.Component<Props> {
    public static List = List;

    public static Item = Item;

    render() {
        const {children, label, width, noIcon = false} = this.props;

        const styledChildren = React.Children.map(children, (child) => {
            if (React.isValidElement<{style?: React.CSSProperties}>(child) && child.type === List) {
                return React.cloneElement(child, {
                    style: {width, ...(child.props.style || {})},
                });
            }
            return child;
        });

        return (
            <Menu>
                {({isExpanded}) => (
                    <>
                        <CustomMenuButton>
                            {noIcon ? (
                                <CustomButtonDiv
                                    isExpanded={isExpanded}
                                    style={{whiteSpace: 'nowrap'}}
                                >
                                    {label}
                                </CustomButtonDiv>
                            ) : (
                                <CustomButton
                                    isExpanded={isExpanded}
                                    style={{whiteSpace: 'nowrap'}}
                                >
                                    {label}
                                    <CustomIcon
                                        name={isExpanded ? 'arrowUp' : 'arrowBottom'}
                                        size={14}
                                    />
                                </CustomButton>
                            )}
                        </CustomMenuButton>
                        {styledChildren}
                    </>
                )}
            </Menu>
        );
    }
}
